import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { formatTextCase } from 'src/app/common/utils/text-case.utils';

export function titleCaseValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value == null || value === '') {
      return null;
    }

    if (typeof value !== 'string') {
      return { titleCase: true };
    }

    const expected = formatTextCase(value, 'title');

    if (value !== expected) {
      return { titleCase: true };
    }
  };
}
